export const ADD_BUNDLE_ITEM = "ADD_BUNDLE_ITEM"
export type ADD_BUNDLE_ITEM = typeof ADD_BUNDLE_ITEM

export const REMOVE_BUNDLE_ITEM = "REMOVE_BUNDLE_ITEM"
export type REMOVE_BUNDLE_ITEM = typeof REMOVE_BUNDLE_ITEM

export const UPDATE_BUNDLE_ITEM = "UPDATE_BUNDLE_ITEM"
export type UPDATE_BUNDLE_ITEM = typeof UPDATE_BUNDLE_ITEM


// WEBPACK FOOTER //
// ./src/state/product/bundle/actions/types.ts